import type { LocationId } from "@redotech/redo-inventory-id";
import type { TransferSessionId } from "@redotech/redo-warehouse-id";

export function replenishmentReportHref(
  warehouseHref: string,
  locationId: string | null,
  viewName?: string,
): string {
  const params = new URLSearchParams();
  if (locationId) {
    params.set("crdbLocationId", locationId);
  }
  if (viewName) {
    params.set("view", viewName);
  }
  const query = params.toString();
  return `${warehouseHref}/replenishment/report${query ? `?${query}` : ""}`;
}

export function replenishmentSourceHref(
  warehouseHref: string,
  locationId: LocationId,
  transferSessionId: TransferSessionId,
): string {
  const params = new URLSearchParams({
    crdbLocationId: locationId,
    transferSessionId,
  });
  return `${warehouseHref}/replenishment/source?${params.toString()}`;
}
